export default __webpack_public_path__ + "static/media/pink2Squiggle.5d25a33d.png";